import styled from "styled-components";

// export const Container = styled.div`
//  background: #5e5e5e;
//  min-height: 100vh;
// `;

export const Selection = styled.div`
font-family: 'Poppins';
font-weight: 700;
font-style: normal;
padding-top: 50px;
font-size: 50px;
padding-left: 40px;
background-color: #5e5e5e;
color: white;

@media (max-width: 430px) {
      font-size: 30px; 
}
`